import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { User } from "src/app/models/user-model";
import { ChildActivationStart, Router } from "@angular/router";

import { Webflow } from "src/app/utils/webflow";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class AuthService {
  entity: string = "/auth";
  public currentUserSubject = new BehaviorSubject<User>(
    JSON.parse(localStorage.getItem("studiomapUser")!)
  );
  currentUser = this.currentUserSubject.asObservable();
  // public currentUser: Observable<User>;
  constructor(private http: HttpClient, private router: Router) {}

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  callCurrentUserSubject(user: any) {
    this.currentUserSubject.next(user);
  }

  login(identifier: string, password: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/local/",
      {
        identifier,
        password,
      },
      httpOptions
    );
  }

  logout() {
    localStorage.removeItem("studiomapUser");
    this.currentUserSubject.next(null);
    if (Webflow.isIFrame()) {
      Webflow.setIFrameHeight();
      window.top.location.href =
        environment.webflow_url + "/app?action=dashboard";
    } else {
      this.router.navigate(["/login"]);
    }
  }

  register(user: User): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/local/register",
      JSON.stringify(user),
      httpOptions
    );
  }

  resetPassword(
    code: string,
    password: string,
    passwordConfirmation: string
  ): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/reset-password",
      {
        code,
        password,
        passwordConfirmation,
      },
      httpOptions
    );
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/forgot-password",
      {
        email,
      },
      httpOptions
    );
  }

  resendConfirmation(email: string): Observable<any> {
    return this.http.post(
      environment.api + this.entity + "/send-email-confirmation",
      {
        email,
      },
      httpOptions
    );
  }

  loginWith(provider: string, filters: string) {
    return this.http.get(
      environment.api + "/auth/" + provider + "/callback/?populate=*" + filters
      //'/callback/?populate=*&access_token=' + token_access
    );
  }
}
